import gql from 'graphql-tag';

// GET ALL MARITAL STATUS
export const getAll = gql`
  query getAllMaritalStatusList {
    getAllMaritalStatusList {
      code
      status
      data {
        id
        name
      }
    }
  }
`;

// ADD MARITAL STATUS
export const save = gql`
  mutation saveMaritalStatus($input: MaritalStatusDtoInput) {
    saveMaritalStatus(maritalStatusDto: $input) {
      code
      status
      data {
        id
        description
        name
      }
    }
  }
`;

// DELETE MARITAL STATUS
export const remove = gql`
  mutation deleteMaritalStatus($input: String) {
    deleteMaritalStatus(maritalStatusId: $input) {
      code
      status
      data {
        name
        description
      }
    }
  }
`;
